// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_2Grlf","tooltipArrow":"_1cr78","rtl":"_3Tu2y","centerAligned":"k5N6J","singleFileBehavior":"_1jzN7","tooltipContainer":"vsBee","tooltipTrigger":"_3EWk9"};